import React from 'react';
import { Typography } from '@material-ui/core';

import SectionContainer from '../Components/SectionContainer';

import logo from '../tim-apple.png';

const TimApple = () => {
  return (
    <SectionContainer>
      <Typography gutterBottom style={{ width: '100%' }} variant='h1'>Tim Apple</Typography>
      <Typography gutterBottom style={{ width: '100%' }}>This is a picture of Tim Apple with some developers, not us.</Typography>
      <img src={logo} style={{ width: '100%' }} alt='It is Tim Apple with some developers, but they ain us.' />
    </SectionContainer>
  )
}

export default TimApple;